import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoDescuentoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetTiposDescuento() {
        return [
            { value: '1', label: 'Monto' },
            { value: '2', label: 'Porcentaje' },
        ];
    }
    obtenerDescuentoProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: [descuentoInputType], $cliente_seleccion: [descuentoInputType]) {
            descuento {
              existeDescuento(entidad: $entidad, cliente_seleccion: $cliente_seleccion) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  registros {
                    rut_cliente
                    codigo_direccion
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.descuento.existeDescuento;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDescuentoMaximoProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: [descuentoMaximoInputType]) {
            descuento_maximo {
              existeDescuento(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  registros {
                    producto_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.descuento_maximo.existeDescuento;
            callback({ mensajes, respuesta });
        });
    }
    obtenerDescuentoCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: descuentoInputType, $cliente_seleccion: [descuentoInputType], $producto_seleccion: [Decimal]) {
            descuento {
              existeDescuentoCliente(entidad: $entidad, cliente_seleccion: $cliente_seleccion, producto_seleccion: $producto_seleccion) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rut_cliente
                    codigo_direccion
                    codigo
                    producto_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.descuento.existeDescuentoCliente;
            callback({ mensajes, respuesta });
        });
    }
}
TipoDescuentoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoDescuentoService_Factory() { return new TipoDescuentoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoDescuentoService, providedIn: "root" });
